export enum VerificationBadgeType {
  QUASI_VERIFIED = 'QUASI_VERIFIED',
  VERIFIED = 'VERIFIED',
  NONE = 'NONE',
}
